import * as React from 'react';
import { limuirsComponent, withScope } from 'limuirs-components';
import { log } from 'limuirs-utils';
import Panel from '../../common/Panel';
import UrlManager from '../../../services/rest/UrlManager';
import NodeAvatar from '../../nodes/NodeAvatar';
import MembershipCount from '../../memberships/MembershipCount';
import NodeTitle from '../../nodes/NodeTitle';
import { scopeType } from '../../../types';

/**
 * Displays a list of group hubs in a panel.
 *
 * @author Adam Ayres
 */
class GroupHubsPanelList extends React.PureComponent {
  static propTypes = {
    /** Defines how to scope the widget, this will be automatically set
     * by the {@code withScope} HoC if not explicitly passed. */
    scope: scopeType.isRequired
  };

  static renderHubItem(group) {
    return (
      <li key={group.id}>
        <div className="lia-group-hubs-panel-list-item">
          <NodeAvatar node={group} />
          <NodeTitle node={group} />
          <MembershipCount node={group} />
        </div>
      </li>
    );
  }

  constructor(props) {
    super(props);
    const { globals, prefetch } = this.props;
    this.urlManager = new UrlManager(globals);
    if (prefetch.isDataLoadedForQuery('groupHubs')) {
      this.groups = prefetch.getData('groupHubs');
      if (!this.groups) {
        const memberships = prefetch.getData('memberships');
        this.groups = memberships && memberships.map(membership => membership.node);
      }
    }

    this.state = {
      ready: prefetch.isDataLoadedForQuery('groupHubs')
    };
  }

  componentDidMount() {
    const { ready } = this.state;
    const { prefetch } = this.props;

    if (!ready) {
      prefetch
        .waitForData('groupHubs')
        .then(data => {
          this.groups = data;
          this.setState({ ready: true });
          return data;
        })
        .catch(error => {
          log.warn('Failed to get group hubs ', error);
        });
    }
  }

  render() {
    const { text, scope } = this.props;
    const { ready } = this.state;

    function getTextKey() {
      return scope.user ? scope.userTextKey : scope.nodeTextKey;
    }

    if (!ready) {
      return <span className="lia-component-loading" />;
    } else {
      return (
        ready &&
        this.groups.length > 0 && (
          <Panel
            header={text.format(getTextKey(), scope)}
            content={<ul>{this.groups.map(group => GroupHubsPanelList.renderHubItem(group))}</ul>}
            viewAllHref={this.urlManager.getGroupHubsPageUrl(scope)}
            panelClass="lia-group-hubs-panel-list"
          />
        )
      );
    }
  }
}

export default limuirsComponent(module, withScope(GroupHubsPanelList));
